// File generated automatically, do not modify

import axios, { AxiosResponse } from 'axios';
import { DoctorMapping, ServiceMapping, Service, ScheduleMapping, AsyncTaskInfo, DoctorBookings, HisEvent, IntegrationEventDto } from './models';

const paths = {
  doctors: 'api/Sync/Doctors',
  services: 'api/Sync/Services',
  activeServices: 'api/Sync/ActiveServices',
  schedules: 'api/Sync/Schedules',
  scheduleForHisDoctor: 'api/Sync/ScheduleForHisDoctor',
  everything: 'api/Sync/Everything',
  deleteOutdatedServiceMappings: 'api/Sync/DeleteOutdatedServiceMappings',
  ignoreCancelled: 'api/Sync/IgnoreCancelled',
  bookings: 'api/Sync/Bookings',
  handleEvent: 'api/Sync/HandleEvent',
  ignoreEvent: 'api/Sync/IgnoreEvent',
  events: 'api/Sync/Events',
  clearCache: 'api/Sync/ClearCache',
};

function doctors(): Promise<DoctorMapping[]> {
  return axios.request<DoctorMapping[]>({
    url: paths.doctors,
    method: 'get',
  }).then(res => res.data);
}

function services(): Promise<ServiceMapping[]> {
  return axios.request<ServiceMapping[]>({
    url: paths.services,
    method: 'get',
  }).then(res => res.data);
}

function activeServices(): Promise<Service[]> {
  return axios.request<Service[]>({
    url: paths.activeServices,
    method: 'get',
  }).then(res => res.data);
}

interface SchedulesParams {
  includeHisOnly?: boolean;
}

function schedules(params: SchedulesParams): Promise<ScheduleMapping[]> {
  return axios.request<ScheduleMapping[]>({
    url: paths.schedules,
    method: 'post',
    params,
  }).then(res => res.data);
}

interface ScheduleForHisDoctorParams {
  hisDoctorId?: number;
  hisUnitId?: number;
  execute?: boolean;
}

function scheduleForHisDoctor(params: ScheduleForHisDoctorParams): Promise<ScheduleMapping> {
  return axios.request<ScheduleMapping>({
    url: paths.scheduleForHisDoctor,
    method: 'post',
    params,
  }).then(res => res.data);
}

function everything(): Promise<AsyncTaskInfo> {
  return axios.request<AsyncTaskInfo>({
    url: paths.everything,
    method: 'post',
  }).then(res => res.data);
}

function deleteOutdatedServiceMappings(): Promise<AxiosResponse<any>> {
  return axios.request<any>({
    url: paths.deleteOutdatedServiceMappings,
    method: 'post',
  });
}

function ignoreCancelled(): Promise<AxiosResponse<any>> {
  return axios.request<any>({
    url: paths.ignoreCancelled,
    method: 'post',
  });
}

function bookings(): Promise<DoctorBookings[]> {
  return axios.request<DoctorBookings[]>({
    url: paths.bookings,
    method: 'get',
  }).then(res => res.data);
}

function handleEvent(data: HisEvent): Promise<AxiosResponse<any>> {
  return axios.request<any>({
    url: paths.handleEvent,
    method: 'post',
    data,
  });
}

interface IgnoreEventParams {
  id?: string;
}

function ignoreEvent(params: IgnoreEventParams): Promise<AxiosResponse<any>> {
  return axios.request<any>({
    url: paths.ignoreEvent,
    method: 'post',
    params,
  });
}

function events(): Promise<IntegrationEventDto[]> {
  return axios.request<IntegrationEventDto[]>({
    url: paths.events,
    method: 'get',
  }).then(res => res.data);
}

function clearCache(): Promise<AxiosResponse<any>> {
  return axios.request<any>({
    url: paths.clearCache,
    method: 'post',
  });
}

export const syncService = {
  paths,
  doctors,
  services,
  activeServices,
  schedules,
  scheduleForHisDoctor,
  everything,
  deleteOutdatedServiceMappings,
  ignoreCancelled,
  bookings,
  handleEvent,
  ignoreEvent,
  events,
  clearCache,
};
